export const DANGER_COLOR = '#C1272D';
export const SUCCESS_COLOR = '#7AB600';
export const WARNING_COLOR = '#EFC700';
